import { EditIdentifierProps } from "./edit-identifier.types";

export const EDIT_IDENTIFIER_DEFAULT_PROPS: Omit<EditIdentifierProps, "seed"> =
  {
    event: "",
    identifier: "",
  };
